module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-content-wrapper"
  }, [_c('div', {
    staticClass: "container-fluid container-fixed-lg"
  }, [_c('div', {
    staticClass: "panel panel-transparent"
  }, [_c('page-title', {
    attrs: {
      "title": _vm.$t('motivoOcorrencia.titulos.listagemTitulo'),
      "subTitle": _vm.$t('motivoOcorrencia.titulos.listagemSubtitulo')
    }
  }, [_c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "slot": "new-button",
      "label": _vm.$t('motivoOcorrencia.labels.novo'),
      "id": "btnNovoMotivoDeOcorrencia",
      "clickFunction": _vm.newOccurrence
    },
    slot: "new-button"
  })], 1), _c('div', {
    attrs: {
      "id": "occurrenceReasons"
    }
  }, [_c('v-client-table', {
    staticClass: "data-table custom-data-table",
    attrs: {
      "data": _vm.reasons,
      "columns": _vm.columns,
      "options": _vm.options
    },
    scopedSlots: _vm._u([{
      key: "acoes",
      fn: function(props) {
        return [(_vm.isLoadingData) ? _c('loading-placeholder') : _vm._e(), (!_vm.isLoadingData) ? _c('div', {
          staticClass: "actions"
        }, [_c('button', {
          staticClass: "fa fa-pencil action",
          attrs: {
            "title": _vm.$t('motivoOcorrencia.labels.editar')
          },
          on: {
            "click": function($event) {
              return _vm.edit(props.row.id)
            }
          }
        }), _c('button', {
          staticClass: "fa fa-times action",
          attrs: {
            "disabled": props.row.emUso,
            "title": props.row.emUso ? _vm.$t('motivoOcorrencia.labels.removeBloqueio') : _vm.$t('motivoOcorrencia.labels.remover')
          },
          on: {
            "click": function($event) {
              return _vm.handleRemove(props.row.id)
            }
          }
        })]) : _vm._e()]
      }
    }])
  }, [_c('template', {
    slot: "filter__categoria"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    on: {
      "input": function($event) {
        return _vm.handleFilter($event, 'categoria')
      }
    }
  })])], 2)], 1)], 1)]), _c('confirm-modal', {
    attrs: {
      "id": "confirmRemoveOccurrence"
    }
  }, [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "col-xs-12 row-filter-small confirm-text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('motivoOcorrencia.labels.confirmarDelete'))
    }
  })]), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button-primary', {
    staticClass: "confirm-buttom",
    attrs: {
      "label": _vm.$t('remessaIntegracao.labels.nao'),
      "customClass": "secondary",
      "id": "btnFecharModalRemoverOcorrencia",
      "clickFunction": _vm.closeModalConfirm
    }
  }), _c('button-primary', {
    staticClass: "pull-right confirm-buttom",
    attrs: {
      "label": _vm.$t('remessaIntegracao.labels.sim'),
      "id": "btnConfirmarModalRemoverOcorrencia",
      "clickFunction": _vm.removeOccurrence
    }
  })], 1)])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3a5894d2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a5894d2"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/views/registration/occurrenceReason/list.pug
// module id = 1400
// module chunks = 0